
import { StrategyBaseClass } from './strategy-base-class.js';
import { TwitterQueueEnum } from 'src/app/shared/strategies/shared/twitter-queue.enum';

export class TwitterService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 2; // alcmeon.db.Sites.TYPE_TWITTER
  }
  getTypeString() {
    return 'twitter';
  }
  getAllTasksTypes() {
    return [TwitterQueueEnum.PRIVATE, TwitterQueueEnum.MENTION,
    ];
  }

  getPrivateTaskTypes() {
    return [TwitterQueueEnum.PRIVATE];
  }

  getPublicTaskTypes() {
    return [TwitterQueueEnum.MENTION];
  }

  getPublicRepliesTaskTypes() {
    return [TwitterQueueEnum.PUBLIC_REPLIES];
  }

  canHaveSurveys() {
    return true;
  }

  getTaskTypesGroups() {
    return [
      {
        translateKey: 'twitter/dm',
        taskTypes: [TwitterQueueEnum.PRIVATE]
      },
      {
        translateKey: 'twitter/mentions',
        taskTypes: [TwitterQueueEnum.MENTION]
      },
      {
        translateKey: 'twitter/public-replies',
        taskTypes: [TwitterQueueEnum.PUBLIC_REPLIES]
      }
    ]
  }

  getTaskTypeString(taskType) {
    const mapping = {
      [TwitterQueueEnum.PRIVATE]: 'twitter/private',
      [TwitterQueueEnum.MENTION]: 'twitter/mention',
      [TwitterQueueEnum.PUBLIC_REPLIES]: 'twitter/public-replies',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    const mapping = {
      [TwitterQueueEnum.PRIVATE]: 'tw-private',
      [TwitterQueueEnum.MENTION]: 'tw-mention',
      [TwitterQueueEnum.PUBLIC_REPLIES]: 'public-replies',
    };
    return mapping[taskType];
  }

  taskTypeHasPublicationFilter(taskType) {
    return taskType === TwitterQueueEnum.MENTION;
  }

  taskTypeHasMentionFilter(taskType) {
    return taskType === TwitterQueueEnum.MENTION;
  }


  taskTypeHasPublicRepliesFilter(taskType) {
    return taskType === TwitterQueueEnum.PUBLIC_REPLIES;
  }

  getEditorConfiguration(isPrivate, isPublication) {
    const config = {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*',
    }
    // Publish doesn't handle multiple messages in the backend (or at least merges them when sending us the last_revision),
    // let's not activate multiple messages at all for publish, for the moment.
    if (!isPrivate && !isPublication) {
      config.canHaveMultipleMessages = true;
      config.canSelectAdditionalRecipients = true; // (at the moment this only displays all recipient)
      config.showAddDMLinkButton = true;
      config.maxMessageLength = 280;
      config.useTwitterTextLib = true;
    }
    return config;
  }

  getQuickRepliesElementsConfig() {
    return {
      maxAnswerNb: 20,
      answerLabelMaxLength: 36,
      hasDescription: true,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: false,
        hasImageControl: false
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: true
    };
  }

  externalInboxURL(site) {
    if (site.authorized_user && site.authorized_user.external_id) {
      return "https://twitter.com/messages/compose?recipient_id=" + site.authorized_user.external_id;
    }
    return null;
  }

  mustCheckIfMessageDeleted(isPrivate) {
    // Check if message is deleted if it is public
    return !isPrivate;
  }

  mustFetchContext(isPrivate) {
    return !isPrivate;
  }

  handlesPublish() {
    return true;
  }


  static TwitterFactory($translate) {
    return new TwitterService($translate);
  }
}
TwitterService.TwitterFactory.$inject = ['$translate'];
